import React from 'react';
import { DialogMessageNotification, DialogMessageRenderer } from '@cp/entities/dialog';
import { MessageType } from '@common/model/dialog/message/messageType';

export const ClientContactsRenderer: DialogMessageRenderer<MessageType.ClientContacts> = (props) => (
  <DialogMessageNotification {...props} text={'Контакты отправлены'} />
);
